import React, { Component } from 'react';
import { connect } from 'react-redux';
//Components
import { Activity } from '../../Components/ActivityCard/ActivityCard';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { getId } from '../../../Utils';
import { Spinner } from '../../Components/Spiner/Spiner';
import { BannerEmptyStatsActivity } from '../../Components/BannerEmptyStats/BannerEmptyStats';
import InfiniteScroll from 'react-infinite-scroll-component';
import './InfiniteScrollStyle.css';
import { ActivityContainer } from './style';
import { Loading } from '../WithLoading/Loading';
import { EmptyState } from '../WithEmptyState/EmptyState';
import { ActivityActionCreators } from '../../../Store/ActionCreators/ActivityActionCreators';

export const ActivityFactoryComponent = ({ filterLayout, ...props }) => {
    switch (filterLayout) {
        case 0:
            return <Activity.Default activity={props} />;
        case 1:
            return <Activity.LeftAlignment activity={props} />;
        case 2:
            return <Activity.CenterAlignment activity={props} />;
        case 3:
            return <Activity.RightAlignment activity={props} />;
        case 4:
            return <Activity.Circles activity={props} />;
        case 5:
            return <Activity.Calories activity={props} />;
        case 6:
            return <Activity.Reps activity={props} />;
        case 7:
            return <Activity.Load activity={props} />;
        case 8:
            return <Activity.Duration activity={props} />;
        case 9:
            return <Activity.Distance activity={props} />;
        case 10:
            return <Activity.Bpm activity={props} />;
        case 11:
            return <Activity.BottomRepsStats activity={props} />;
        case 12:
            return <Activity.MiddleRepsStats activity={props} />;
        case 13:
            return <Activity.TopRepsStats activity={props} />;
        case 14:
            return <Activity.TextOnly activity={props} />;
        default:
            return <Activity.TextOnly activity={props} />;
    }
};

class ActivityList extends Component {
    // getting additional activity for an infinite scroll
    loadMoreWorkouts = (lastWorkoutId, lastWorkoutDate) => {
        const { loadMoreActivity, match } = this.props;
        const PROFILE_ID = getId(match.params.profileId);

        loadMoreActivity(PROFILE_ID, lastWorkoutId, lastWorkoutDate);
    };

    componentWillUnmount() {
        this.props.resetScroll();
    }

    render() {
        const { activity, isActivityLoading, moreActivityToLoad, metric } = this.props;
        const SCROLL_LENGTH = Array.from({ length: 20 });
        const isActivityEmpty = activity.length === 0;

        return (
            <Loading isLoading={isActivityLoading}>
                <EmptyState isEmpty={isActivityEmpty} emptyState={BannerEmptyStatsActivity}>
                    <ActivityContainer>
                        <InfiniteScroll
                            style={{ overflow: 'hidden' }}
                            dataLength={SCROLL_LENGTH}
                            next={() =>
                                this.loadMoreWorkouts(
                                    activity[activity.length - 1].id,
                                    activity[activity.length - 1].createdAt,
                                )
                            }
                            hasMore={moreActivityToLoad}
                            loader={<Spinner />}
                        >
                            {activity.map(act => (
                                <div key={act.id} className="activity-item">
                                    <ActivityFactoryComponent hasLink={true} metric={metric} {...act} />
                                </div>
                            ))}
                        </InfiniteScroll>
                    </ActivityContainer>
                </EmptyState>
            </Loading>
        );
    }
}

const mapStateToProps = ({
    user: { currentUserPreferences },
    activity: { activity, statuses, moreActivityToLoad },
}) => {
    return {
        activity,
        moreActivityToLoad,
        isActivityLoading: statuses.isActivityLoading,
        metric: currentUserPreferences.metric,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadMoreActivity(userId, offsetId, offsetDate) {
            dispatch(ActivityActionCreators.loadMoreActivityRequest(userId, offsetId, offsetDate));
        },
        resetScroll() {
            dispatch({ type: 'RESET_ACTIVITY_SCROLL ' });
        },
    };
};

export default compose(
    withRouter,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ActivityList);



// WEBPACK FOOTER //
// ./src/UI/Containers/ActivityList/ActivityList.js